"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Aug 09 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../../modules/AppModule");

var CodebookItemConverter_1 = require("./conversions/CodebookItemConverter");

var CodebookItemConverterImpl_1 = require("./conversions/CodebookItemConverterImpl");
/**
 * Codebook feature of application.
 *
 * @author Radek Beran
 */


var CodebookAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(CodebookAppModule, _AppModule_1$AppModul);

  function CodebookAppModule() {
    var _this;

    _classCallCheck(this, CodebookAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CodebookAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'codebook';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(CodebookAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(CodebookItemConverter_1.CodebookItemConverter).to(CodebookItemConverterImpl_1.CodebookItemConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return CodebookAppModule;
}(AppModule_1.AppModule);

exports.CodebookAppModule = CodebookAppModule;